import type { MarketVariants } from '@/lib/i18n'

export type Slide2BridgeCopy = { body: string }

export const copy: MarketVariants<Slide2BridgeCopy> = {
  US: {
    body:
      'Scammers look for easy ways in. This chapter covers a few simple habits that make it much harder for them to access your accounts or misuse your personal information.',
  },
  ar: {
    body:
      'يبحث المحتالون عن أسهل الطرق للوصول إليك. يتناول هذا الفصل بضع عادات بسيطة تجعل وصولهم إلى حساباتك أو إساءة استخدام معلوماتك الشخصية أصعب بكثير.',
  },
}
